import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const TabRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
  padding: ${spacing[4]} ${spacing[3]} ${spacing[3]};
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${rawColors.text.lowEmphasis};
`;

export const SectionTitle = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px ${spacing[2]};
  background-color: ${rawColors.structural[100]};
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.sm};
  ${typographyMixin("overline", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const LinkedName = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.primary[500]};
  text-decoration: underline;
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TableNameButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  display: block;
  width: 100%;
  min-width: 0;

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
    border-radius: ${borderRadius.sm};
  }
`;

export const EmptyHint = styled.p`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.lowEmphasis};
`;
